import Image from "next/image"
import Link from "next/link"

import facebook from './icons/facebook.svg'
import instagram from './icons/instagram.svg'
// import tiktok from './icons/tiktok.svg'
import whatsapp from './icons/whatsapp.svg'
import { twMerge } from "tailwind-merge"

const icons = [
  {
    icon: whatsapp,
    alt: "whatsapp",
    href: "https://wa.me/48575109749"
  },
  {
    icon: facebook,
    alt: "facebook",
    href: "https://www.facebook.com/petrolboys.import"
  },
  {
    icon: instagram,
    alt: "instagram",
    href: "https://www.instagram.com/petrolboys.import"
  },
]

type TSocialLinks = {
  rotateIcons?: boolean;
  variant?: 'default' | 'contrast';
  iconColor?: 'dark' | 'light';
}

export const SocialLinks = ({ rotateIcons, variant = 'default', iconColor = 'dark' }: TSocialLinks) => {
  const linkClasses = twMerge(
    'w-8 transition-all hover:brightness-75 flex items-center justify-center rounded-full',
    rotateIcons && 'rotate-90',
    variant === 'contrast' && 'w-10 h-10 border border-foreground/40 text-foreground hover:border-foreground/60'
  );

  const imageClasses = twMerge('w-full', (variant === 'contrast' || iconColor === 'light') && 'invert');

  return (
    <div className="flex flex-row gap-4 items-center justify-center">
      {icons.map(item => (
        <Link href={item.href} key={item.alt} target="_blank" rel="noopener noreferrer" className={linkClasses}>
          <Image src={item.icon} alt={item.alt} className={imageClasses} />
        </Link>
      ))}
    </div>
  );
};
